import { parsePriceVariant } from '@/ui/utils/parsePriceVariant';
import { componentByTypename } from '@/ui/utils/componentByTypename';
import {
  parseColorDetail,
  parseRelationTileDetail,
} from '@/integrations/crystallize/helpers/product-variant-helper';
import {
  CrystallizeProductTypeDefault,
  CrystallizeProductTypeValues,
} from '@/integrations/crystallize/types/constants';
import { ParsedHardwareProductVariant } from '../types/ParsedHardwareProductVariant';
import { NestedProductVariant } from '../types/NestedProductVariant';
import { parseWarehouseDetails } from './parseWarehouseDetails';

export function parseNestedProductVariant(
  variant: NestedProductVariant,
): ParsedHardwareProductVariant {
  return {
    name: variant.name!,
    sku: variant.sku,
    priceVariant: parsePriceVariant(variant.priceVariant),
    isDefault: variant.isDefault || false,
    images: variant.firstImage ? [variant.firstImage] : [],
    videos: [],
    subscriptionPlan: variant.subscriptionPlans?.[0],
    warehouseDetails: parseWarehouseDetails(variant.warehouseDetails) || null,
    stockCount: variant.stock || null,
    isGlobal: componentByTypename(variant.isGlobal?.content, 'BooleanContent')?.value || null,
    productType:
      (componentByTypename(variant.productType?.content, 'SelectionContent')?.options?.[0]
        ?.key as CrystallizeProductTypeValues) || CrystallizeProductTypeDefault,
    color: parseColorDetail(componentByTypename(variant.color?.content, 'SelectionContent')),
    cylinder: parseRelationTileDetail(
      componentByTypename(variant.cylinder?.content, 'ItemRelationsContent'),
    ),
  };
}
